import type { RootState } from '@/app/store';

// Basic selectors
export const selectOutputMaterialsData = (state: RootState) =>
  state.matchMaker.outputMaterialListData;
export const selectOutputMaterialsLoading = (state: RootState) =>
  state.matchMaker.loading;
export const selectOutputMaterialsError = (state: RootState) =>
  state.matchMaker.error;
